/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  ITB_CLICK: 'ITB_CLICK',
}

export const gtmEvents = {
  [gtmEventTypes.ITB_CLICK]: ({
                                name, id, category, actionMessage, customValue, version,
                              }) => ({
    type: gtmEventTypes.ITB_CLICK,
    event: gtmEventTypes.ITB_CLICK,
    eventID: id,
    pageCategory: category,
    customValue: customValue,
    version,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/image-tout-block-duck.js